import { useEffect } from 'react'
import { hideChat, isChatHidden, showChat } from '../util/set-crisp-session-info'

// Hides the Crisp launcher while `active`, e.g. under a bar fixed to the bottom of the screen that the
// launcher would cover. Unlike useCrispYield it registers no yield handler, which is one slot owned by
// the Vee assistant, so Crisp can still show itself for an operator message.
export const useHideCrispWhile = (active: boolean): void => {
  useEffect(() => {
    if (!active) {
      return
    }
    // Chat can already be hidden for other reasons; only re-show it if this hid it.
    const wasHidden = isChatHidden()
    hideChat()
    return () => {
      if (!wasHidden) {
        showChat()
      }
    }
  }, [active])
}
